import { render, staticRenderFns } from "./ReciboPreview.vue?vue&type=template&id=d0fe760a&"
import script from "./ReciboPreview.vue?vue&type=script&lang=js&"
export * from "./ReciboPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports